import { all, call, put, takeEvery } from 'redux-saga/effects';

import { CREATE_PROSPECTS, GET_REGISTER_DATA } from '../constants/prospect';
import { GET_QUESTIONS } from '../constants/assessmentSectionQuestions';
import Api from '../../utils/api';
import { fetchQuestionsFailure, fetchQuestionsSuccess } from '../actions/assessmentSectionQuestions';
import { createProspectsSuccess, createProspectsFailure, getRegisterDataSuccess, getRegisterDataFailure } from '../actions/prospect';

function* getQuestions() {
    try {
        const response = yield call(Api.get, `/public/demo/questions`);
        const questions = response.data;
        yield put(fetchQuestionsSuccess(questions));
    } catch (error) {
        yield put(fetchQuestionsFailure(error));
    }
}

function* createProspects({ values, actions: { toQuestions } }) {
    try {
        const data = yield call(Api.post, `/public/demo/create/lead`, {
            data: values,
        });
        yield put(createProspectsSuccess({ ...values, ...data }));
        yield call(toQuestions({ ...values, ...data.data }));
    } catch (error) {
        createProspectsFailure(error);
    }
}

function* getRegisterData() {
    try {
        const response = yield call(Api.get, '/public/ssp/register/initial-data');
        const project = response.data;
        yield put(getRegisterDataSuccess(project));
    } catch (e) {
        yield put(getRegisterDataFailure(e.message));
    }
}

export default function* prospect() {
    yield all([
        takeEvery(GET_QUESTIONS, getQuestions),
        takeEvery(CREATE_PROSPECTS, createProspects),
        takeEvery(GET_REGISTER_DATA, getRegisterData),
    ]);
}
